module.exports = "<i class=\"search\"></i>\r\n\r\n<input class=\"\" type=\"text\" placeholder=\"משלוח אוכל\" />\r\n"